import { render, staticRenderFns } from "./ReceiptsPage.vue?vue&type=template&id=0bcee604&scoped=true&"
import script from "./ReceiptsPage.vue?vue&type=script&lang=js&"
export * from "./ReceiptsPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsPage.vue?vue&type=style&index=0&id=0bcee604&lang=scss&scoped=true&"
import style1 from "./ReceiptsPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcee604",
  null
  
)

export default component.exports